module.exports = __webpack_public_path__ + "img/zh_hk.17f76952.png";